import types from 'actions/types'
import {combineReducers} from 'redux'
import {ContactListType} from 'helpers/contactLists'
import {isNil} from 'lodash'

export const search = (state = null, action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_SEARCH:
      return action.phrase
    case types.CONTACT_LISTS_SELECT_CATEGORY:
      return null // reset on select category
    default:
      return state
  }
}

export const showingHiddenLists = (state = false, action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_TOGGLE_HIDDEN_LISTS:
      return action.show
    default:
      return state
  }
}

const selectedCategoryId = (state = ContactListType.ROOT, action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_SELECT_CATEGORY:
      return action.categoryId
    case types.CONTACT_LISTS_ADD_CATEGORY_SUCCESS:
      return action.data.id
    case types.CONTACT_LISTS_DELETE_CATEGORIES_SUCCESS:
      return isNil(action.adoptCategoryId)
          ? ContactListType.ROOT
          : action.adoptCategoryId
    default:
      return state
  }
}

const expandedCategories = (state = [], action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_EXPAND_CATEGORY:
      return [...state, action.categoryId]
    case types.CONTACT_LISTS_COLLAPSE_CATEGORY:
      return state.filter(c => c !== action.categoryId)
    default:
      return state
  }
}

export default combineReducers({
  search,
  showingHiddenLists,
  selectedCategoryId,
  expandedCategories,
})
